module.exports = __webpack_public_path__ + "images/init/upcoming-empty@2x-bc08708ec489626807c67904cf827ef2.png";